"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get SelectionIdParams () {
        return SelectionIdParams;
    },
    get SelectionManagersResponse () {
        return SelectionManagersResponse;
    },
    get SelectionSalarySummaryResponse () {
        return SelectionSalarySummaryResponse;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const SelectionIdParams = _zod.z.object({
    userSelectionId: _utilsisomorphic.transformObjectId
});
const SelectionSalarySummaryResponse = _zod.z.object({
    totalSalary: _zod.z.number(),
    employeeCount: _zod.z.number(),
    employeesWithoutSalary: _zod.z.number()
});
const SelectionManagersResponse = _zod.z.object({
    managers: _zod.z.array(_zod.z.object({
        _id: _zod.z.string(),
        name: _zod.z.string(),
        directReportCount: _zod.z.number(),
        totalCompensation: _zod.z.number()
    }))
});
